import * as Yup from 'yup';

export interface CreateJourneyFlowData {
  name: string;
  code: string;
  warehouse: string;
  orderType: string;
  carrierType: string;
}

const requiredMessages = {
  name: 'Nome do flow é obrigatório',
  code: 'Código do flow é obrigatório',
  orderType: 'Tipo de ordem é obrigatório',
  carrierType: 'Tipo de transportadora é obrigatório',
};

export class CreateJourneyFlowValidator {
  public get schema() {
    return Yup.object().shape({
      name: Yup.string().trim().required(requiredMessages.name),
      code: Yup.string().trim().required(requiredMessages.code),
      // Empty warehouse represents a global flow (warehouseId null).
      warehouse: Yup.string().trim(),
      orderType: Yup.string().trim().required(requiredMessages.orderType),
      carrierType: Yup.string().trim().required(requiredMessages.carrierType),
    });
  }
}

export const validateJourneyFlow = async (
  values: CreateJourneyFlowData
): Promise<Record<string, string>> => {
  const errors: Record<string, string> = {};

  try {
    await new CreateJourneyFlowValidator().schema.validate(values, {
      abortEarly: false,
    });
  } catch (error) {
    if (error instanceof Yup.ValidationError) {
      error.inner.forEach(({ path, message }) => {
        if (path && !errors[path as keyof CreateJourneyFlowData]) {
          errors[path as keyof CreateJourneyFlowData] = message;
        }
      });
    }
  }

  return errors;
};
